import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   rec:null
};

// getters
const getters = {
};

// actions
const actions = {
   SEWER_MAIN_ZOOM_TO:(context, {sewer})=>{
      context.commit('MAP_FIT_BOUNDS', {bounds:state.rec.bounds,maxZoom:17});
   },
   SEWER_MAIN_HIGHLIGHT:(context, {})=>{
      const feature = {
         styleLayer: 'sewer-mains',
         source: 'scoutred',
         sourceLayer: 'sewer_mains',
         id: state.rec.id,
         properties:{
            geohash:state.rec.geohash
         }
      };
      context.commit('MAP_FEATURE_ACTIVE_SET', feature);
   },
   SEWER_MAIN_HIGHLIGHT_CLEAR:(context, {})=>{
      context.commit('MAP_FEATURE_ACTIVE_SET', null);
   },
   SEWER_MAIN_GET:(context, {id})=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/sewer-mains/'+ id)
         .then((res)=>{
            context.commit('SEWER_SET', {rec: res.data});
            resolve();
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('sewer main',error)});
            reject(apiError.message('sewer main',error));
         });
      });
   }
};

// mutations
const mutations = {
   SEWER_SET:(state,{rec})=>{
      state.rec = rec;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/sewer-main.js